<template>
    <!-- Responsive home page layout -->
    <v-app>
        <v-container>
            <v-row>
                <!-- Navigation Bar -->
                <v-col cols="12" class="mb-8">
                    <NavBar pageTitle="Workbook" />
                </v-col>
                <v-col cols="12" class="flex-box">
                    <v-card outlined class="text-pure-white bg-aqua-teal mb-4">
                        <v-card-title class="text-center text-wrap">Workbook</v-card-title>
                        <v-card-text>
                            Complete exercises, videos, and readings for your therapy plan.
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <!-- Display content in v-col below. -->
            <v-divider class="border-opacity-25 mb-4"></v-divider>
            <template v-if="planId">
            <div class="d-flex justify-end">
                <v-btn-toggle>
                    <v-btn v-show="expandValue == 0" @click="setPanels(0)" icon="mdi-arrow-collapse" />
                    <v-btn v-show="expandValue == 1" @click="setPanels(1)" icon="mdi-arrow-expand" />
                </v-btn-toggle>
            </div>
            <v-expansion-panels v-model="openedPanels" multiple>
                <v-expansion-panel>
                    <template v-slot:title>
                        In Progress
                    </template>

                    <v-expansion-panel-text>
                        <div class="flex-box">
                            <TaskContentList :items="getActiveContent" @update-task-status="updateTaskStatus" />
                        </div>
                    </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                    <template v-slot:title>
                        Not started
                    </template>

                    <v-expansion-panel-text>
                        <div class="flex-box">
                            <TaskContentList :items="getInactiveContent" @update-task-status="updateTaskStatus" />
                        </div>
                    </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel>
                    <template v-slot:title>
                        Completed
                    </template>

                    <v-expansion-panel-text>
                        <div class="flex-box">
                            <TaskContentList :items="getCompletedContent" @update-task-status="updateTaskStatus" />
                        </div>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
            </template>
            <template v-else>
                <div class="d-flex justify-center text-wrap bg-aqua-teal pa-5 mx-5">
                   <h4 class="d-flex text-center">You currently have no active plans.</h4>
                </div>
            </template>
        </v-container>
        <!-- Footer -->
        <MENDFooter></MENDFooter>
    </v-app>
</template>

<script>
import MENDFooter from '../MENDFooter.vue';
import NavBar from '../NavBar.vue';
import TaskContentList from './TaskContentList.vue';
import axios from 'axios';

export default {
    name: 'WorkbookPage',
    components: {
        TaskContentList,
        MENDFooter,
        NavBar,
    },
    data() {
        return {
            contentType: {
                choiceNumber: 0,
                choiceName: 'Video'
            },
            expandValue: 0,
            assignments: [],
            assignedTasks: [],
            openedPanels: [],
            workbookContent: [],
            planId: null,
            patientId: null,
        };
    },
    async mounted() {
        this.patientId = localStorage.getItem("patientId");
        await this.fetchAssignments();
        await this.fetchTasks();
        await this.fetchContent();
        this.setPanels(1);
        this.expandValue = 1;
    },
    methods: {
        async fetchAssignments() {
            this.tasks = []
            try {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                const response = await axios.get(`/api/patientassignment/${this.patientId}`);
                this.tasks = response.data;
                this.planId = (this.tasks.length > 0) ? this.tasks[0].planId : null;
                console.log(`Plan Id: ${this.planId}`);
            } catch (error) {
                console.log(error);
            }
        },
        async fetchTasks() {
            if (this.planId) {
                try {
                    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                    const response = await axios.get(`/api/assignedtask/${this.planId}`);
                    this.assignedTasks = response.data;
                } catch (error) {
                    console.log(error);
                }
            }
        },
        async fetchContent() {
            this.workbookContent = [];
            if (this.assignedTasks.length > 0) {
                try {
                    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                    const contentIds = this.assignedTasks.map(task => `${task.contentId}`);
                    const response = await axios.post("/api/unifiedcontent/contentid/array", { ids: contentIds });
                    const contents = response.data;
                    const tasks = this.assignedTasks;
                    const assignments = this.assignments;
                    console.log(assignments);
                    for (let i = 0; i < contents.length; i++) {
                        this.workbookContent.push({ ...contents[i], ...tasks[i], ...assignments[i] })
                    }
                    console.log(this.workbookContent);
                } catch (error) {
                    console.log(error);
                }
            }
        },
        async updateTaskStatus(task) {
            const index = this.workbookContent.findIndex(e => e.assignedTaskId === task.assignedTaskId);

            if (index != -1) {
                this.workbookContent[index] = task;
                try {
                    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                    let apiUrl = `api/assignedtask/${task.assignedTaskId}`;
                    if (task.taskCompletionDate != null) {
                        const now = new Date();
                        const offsetMs = now.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
                        const localISOTime = new Date(now - offsetMs).toISOString().slice(0, -1); // Remove 'Z'
                        apiUrl = apiUrl + `?completionDate=${localISOTime}`;
                    }
                    await axios.put(apiUrl, task);
                } catch (error) {
                    console.log(error);
                }

            }
        },
        compareContent(a, b) {
            if (a.contentBlock > b.contentBlock) {
                return 1;
            } else if (a.contentBlock < b.contentBlock) {
                return -1;
            } else {
                return 0;
            }
        },
        setPanels(value) {
            this.openedPanels = [];
            if (value === 1) {
                for (let i = 0; i < 3; i++) {
                    this.openedPanels.push(i);
                }
            }
        }
    },
    watch: {
        openedPanels() {
            if (this.openedPanels.length === 3) {  // All panels opened
                this.expandValue = 0;
            } else if (this.openedPanels.length === 0) {  // All panels closed
                this.expandValue = 1;
            }
        },
    },
    computed: {
        getContent() {   // Get page content list
            if (this.workbookContent.length > 0) {
                return this.workbookContent;
            }
            return [];
        },
        getInactiveContent() {
            let content = this.workbookContent.filter(content => content.status === "Not started");
            content.sort((a, b) => this.compareContent(a, b));
            return content;
        },
        getActiveContent() {
            let content = this.workbookContent.filter(content => content.status === "In Progress");
            content.sort((a, b) => this.compareContent(a, b));
            return content;
        },
        getCompletedContent() {
            let content = this.workbookContent.filter(content => content.status === "Complete");
            content.sort((a, b) => this.compareContent(a, b));
            return content;
        }
    }
};
</script>

<style scoped>
* {
    font-family: 'Montserrat';
}

.flex-box {
    display: flex;
    justify-content: center;
}

.text-pure-white {
    color: #FFFFFF;
}

.bg-aqua-teal {
    background-color: #08B6AA;
}

.subpage-link {
    color: #08B6AA;
    cursor: pointer;
    text-decoration: underline;
}

.text-center {
    text-align: center;
}
</style>
